import { FaCarSide, FaCar, FaCarRear } from 'react-icons/fa6';
import images from './images';

const pricing = [
    {
        id: 1,
        image: images.plan1,
        icon: <FaCarSide />, // Icon for Economy Package
        title: 'Economy Package',
        price: 29.99,
        features: [
            'Fuel-Efficient Cars',
            'Ideal for City Travel',
            '24/7 Roadside Assistance',
            'Unlimited Mileage',
            'Affordable Pricing',
        ],
    },
    {
        id: 2,
        image: images.plan2,
        icon: <FaCar />, // Icon for Standard Package
        title: 'Standard Package',
        price: 49.99,
        features: [
            'Comfortable Sedans & SUVs',
            'GPS Navigation Included',
            'Free Additional Driver',
            'Flexible Pickup & Drop-off',
            'Comprehensive Insurance',
        ],
    },
    {
        id: 3,
        image: images.plan3,
        icon: <FaCarRear />, // Icon for Luxury Package
        title: 'Luxury Package',
        price: 99.99,
        features: [
            'Premium Cars (BMW, Audi)',
            'Personalized Chauffeur Service',
            'VIP Customer Support',
            'Airport Pickup Available',
            'Complimentary Refreshments',
        ],
    },
];

export default pricing;